import { render, staticRenderFns } from "./ThreeWorld.vue?vue&type=template&id=ffc66ac4&"
import script from "./ThreeWorld.vue?vue&type=script&lang=js&"
export * from "./ThreeWorld.vue?vue&type=script&lang=js&"
import style0 from "./ThreeWorld.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports